<template>
  <div :class="$style.wrapper">
    <div :class="$style.confirmationCard">Thank you for your submission!</div>
    <div
      :class="$style.closeButtonWrapper"
      @click="handleOutsideClick"
      v-touch="handleOutsideClick"
    >
      <CloseButton></CloseButton>
    </div>
    <div :class="$style.cardWrapper" v-click-outside="handleOutsideClick">
      <div :class="$style.imageContainer">
        <img src="/static//images/prep-kit.jpg" />
      </div>
      <form action="https://buntingroup.us4.list-manage.com/subscribe/post?u=5dc7319145873148829717a17&amp;id=2f66b8d783" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" novalidate>
        <div
          v-if="info && info.prizeModal"
          :class="$style.textContainer"
        >{{ info.prizeModal.content }}</div>
        <div :class="$style.inputContainer">
          <input v-model="nameText" name="FNAME" placeholder="FIRST NAME" id="mce-FNAME" />
        </div>
        <div :class="$style.inputContainer">
          <input v-model="emailText" @input="validateEmail" name="EMAIL" placeholder="EMAIL ADDRESS" id="mce-EMAIL"  />
        </div>
        <div :class="$style.submitWrapper">
          <input type="submit" value="SUBMIT" name="subscribe" id="mc-embedded-subscribe"
          :class="[$style.submitButton, {
              [$style.disable]: !isEmailValid
            }]">
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UiButton from "./UiButton";
import vClickOutside from "v-click-outside";
import CloseButton from "./svgs/CloseButton";

export default {
  components: {
    UiButton,
    CloseButton
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      text:
        "It's important to have everything you'll need ready when disaster strikes.  Enter your name and email address to win a Seventy2 Survival System from Uncharted Supply Co.",
      isShowing: false,
      isEmailValid: false,
      emailText: "",
      nameText: ""
    };
  },
  computed: {
    ...mapGetters({
      info: "content/all"
    })
  },
  mounted() {
    this.$bus.$on("show-prize-modal", this.handleShowModal);
  },
  methods: {
    handleOutsideClick() {
      if (this.isShowing) {
        this.handleCloseClick();
      }
    },
    handleShowModal() {
      this.emailText = "";
      this.nameText = "";
      this.isEmailValid = false;

      // fade in background
      TweenMax.to("." + this.$style.wrapper, 0.5, {
        opacity: 1
      });
      // fade in card
      TweenMax.to("." + this.$style.cardWrapper, 0.5, {
        opacity: 1,
        delay: 0.2,
        onComplete: () => {
          TweenMax.set("." + this.$style.wrapper, {
            pointerEvents: "auto"
          });

          this.isShowing = true;
        }
      });
    },
    validateEmail() {
      if (this.checkIfEmailIsValid(this.emailText)) {
        this.isEmailValid = true;
      } else {
        this.isEmailValid = false;
      }
    },
    checkIfEmailIsValid(email) {
      const re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    handleCloseClick() {
      // fade out card
      TweenMax.to("." + this.$style.cardWrapper, 0.5, {
        opacity: 0
      });
      // fade out background
      TweenMax.to("." + this.$style.wrapper, 0.5, {
        opacity: 0,
        delay: 0.2,
        onComplete: () => {
          TweenMax.set("." + this.$style.wrapper, {
            pointerEvents: "none"
          });

          this.isShowing = false;
        }
      });
    },
    handleSubmitClick() {
      // fire off analytics
      if (this.$ga) {
        this.$ga.event({
          eventCategory: "Forms",
          eventAction: "submitted",
          eventLabel: "Sweepstake"
        });
      }

      // fade out input card
      TweenMax.to("." + this.$style.cardWrapper, 0.5, {
        opacity: 0
      });
      // fade in confirmation card
      TweenMax.to("." + this.$style.confirmationCard, 0.5, {
        opacity: 1
      });
      // hide confirmation card after X seconds
      TweenMax.to("." + this.$style.confirmationCard, 0.5, {
        opacity: 0,
        delay: 2,
        onComplete: () => {
          this.handleCloseClick();
        }
      });
    }
  }
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  background-color: rgba(255, 255, 255, 0.95);

  z-index: 999999;

  font-weight: bold;

  color: #616161;

  opacity: 0;
  pointer-events: none;
}

.close-button-wrapper {
  position: absolute;
  top: 20px;
  z-index: 999999999;

  @include large {
    position: static;
    transform: translateY(-30px);
    top: 100px;
  }

  font-weight: bold;

  cursor: pointer;

  & svg {
    height: 15px;
  }
}

.card-wrapper {
  position: relative;
  height: 100%;
  width: 100%;

  @include large {
    width: 420px;
    height: auto;
    border-radius: 15px;
  }

  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  background-color: rgba(255, 255, 255, 1);

  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.45);
}

.submit-wrapper {
  // position: absolute;
  // bottom: 0;
  // left: 50%;
  // transform: translateX(-50%);

  padding-top: 40px;
  padding-bottom: 40px;

  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 60px;
  @include large {
    margin-top: 40px;
  }
  & img {
    // width: 200px;
    width: calc(100% - 200px);
    margin-bottom: 20px;

    @include large {
      width: calc(100% - 20px);
    }
  }
}

.submit-button {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 45px;
  background-color: $jaffa;

  height: 45px;
  width: 120px;

  padding-left: 40px;
  padding-right: 40px;

  color: white;
  font-weight: bold;

  cursor: pointer;

  border: none;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: darken($jaffa, 15%);
  }

  // &:before {
  //   position: absolute;
  //   z-index: 0;
  //   top: 50%;
  //   left: 100%;
  //   margin: -15px 0 0 1px;
  //   width: 30px;
  //   height: 30px;
  //   border-radius: 50%;
  //   background-color: darken($jaffa, 15%);
  //   transform-origin: 100% 50%;
  //   transition: transform 0.3s, opacity 0.3s;
  //   content: "";
  // }

  // &:hover,
  // &:focus {
  //   &:before {
  //     transform: scale3d(12, 12, 1);
  //   }
  // }

}

.disable {
  opacity: 0.3;
  pointer-events: none;
}

.input-container {
  display: flex;
  justify-content: center;
  align-items: center;

  padding-left: 40px;
  padding-right: 40px;

  margin-bottom: 20px;

  & input {
    height: 45px;
    width: 100%;

    background-color: #e7e8e7;

    padding-left: 20px;

    border-radius: 30px;

    border: none;

    font-weight: bold;
    font-size: 13px;

    outline: none;
    -webkit-appearance: none;
    box-shadow: none !important;
  }
}

.text-container {
  padding-left: 40px;
  padding-right: 40px;

  margin-bottom: 20px;

  line-height: 21px;

  color: $emperor;

  @include large {
    line-height: 32px;
  }
}

.confirmation-card {
  position: absolute;
  top: 50%;
  left: 50%;

  background-color: white;

  padding: 50px;

  border-radius: 15px;

  font-weight: bold;

  display: flex;
  justify-content: center;
  align-items: center;

  transform: translate(-50%, -50%);

  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.45);

  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/PrizeModal.vue